import { gql } from '@apollo/client'

export const LINK_NODE = gql`
  fragment LinkNode on Link {
    url
    title
    linkType
  }
`
